export default {
    cz: {
        megamenu: {
            allCategories: 'Všechny kategorie',
            otherCategories: 'Další kategorie',
        },
    },
    sk: {
        megamenu: {
            allCategories: 'Všetky kategórie',
            otherCategories: 'Ďalšie kategórie',
        },
    },
}
